import { atom } from 'jotai';

export const initialDistinctIdAtom = atom<string | undefined>(undefined);
